//
// Action types
//

export const SET_MAP_VIEWPORT = "SET_MAP_VIEWPORT";
export const SET_MAP_ZOOM = "SET_MAP_ZOOM";

//
// Action creators
//

export function setMapViewport(mapKey, viewport) {
  return {
    type: SET_MAP_VIEWPORT,
    mapKey,
    viewport
  };
}

export function setMapZoom(mapKey, zoom) {
  return {
    type: SET_MAP_ZOOM,
    mapKey,
    zoom
  };
}

function setMapViewportHandler(state, viewport) {
  return { ...state, ...viewport };
}

function setMapZoomHandler(state, zoom) {
  return { ...state, zoom };
}

//
// Reducer and handlers
//

export function reduceMapViewport(state, action) {
  switch (action && action.type) {
    case SET_MAP_VIEWPORT:
      return setMapViewportHandler(state, action.viewport);

    case SET_MAP_ZOOM:
      return setMapZoomHandler(state, action.zoom);

    default:
      return state || {};
  }
}
